import {supplyEventInAction} from "@/components/common/controlBar/controlBarDialog/event/washData.js";
import {getAncestorCombinedNode} from "@/composables/newUtils.js";
export function washData_textTitle(walkedNode) {
  var ancestorCombinedNode = getAncestorCombinedNode(walkedNode)
  if(!ancestorCombinedNode){
    walkedNode._isEnhanceTextOverFlow = true
  }

  supplyEventInAction(walkedNode)
}
